import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

interface Props {
  type: "booked" | "available";
  title: string;
  description: string | string[];
  amount: string;
  interval: string;
  image?: string;
  beginDate?: string;
  minDuration?: string;
  cancelledDate?: string;
  appCurrency: string;
  buttonOnClick: (e: any, id: string | number) => void;
  id: string | number;
}

export default function AbonnementCard({
  title,
  description,
  amount,
  image,
  interval,
  minDuration,
  cancelledDate,
  appCurrency,
  beginDate,
  type,
  buttonOnClick,
  id
}: Props) {
  return (
    <article className="abo-card">
      {image && <img className="abo-card-image" src={image} alt={title} />}
      <header className="abo-card-header">
        <div className="abo-card-title-container">
          <h3 className="abo-card-title">{title}</h3>
          {type === "booked" && beginDate && (
            <time className="abo-card-begin-date" dateTime={beginDate}>
              {beginDate} <span className="abo-card-begin-date-bg" />
            </time>
          )}
        </div>
        <p className="abo-card-price">
          {amount}
          <span className="abo-card-currency">{appCurrency}</span>
          <span className="abo-card-interval">/ {interval}</span>
        </p>
      </header>
      {Array.isArray(description) ? (
        <ul className="abo-card-description-list">
          {description.map((desc, idx) => (
            <div className="abo-card-description-list-container" key={idx}>
              <FontAwesomeIcon
                className="abo-card-description-list-icon"
                icon={faCheck}
              />
              <li className="abo-card-description-list-item" key={idx}>
                {desc}
              </li>
            </div>
          ))}
        </ul>
      ) : (
        <p className="abo-card-description">{description}</p>
      )}
      <footer className="abo-card-footer">
        <button
          className={`core-btn ${
            cancelledDate
              ? "deactivated"
              : type === "booked"
                ? "outline color-important border-color-important"
                : ""
          } abo-card-btn`}
          onClick={e => (cancelledDate ? null : buttonOnClick(e, id))}
        >
          {cancelledDate
            ? `Gekündigt zum ${cancelledDate}`
            : type === "booked"
              ? "Kündigen"
              : "Abonnieren"}
        </button>
        {minDuration && (
          <p className="abo-card-min-duration">Mindestlaufzeit {minDuration}</p>
        )}
      </footer>
    </article>
  );
}
